import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublishersList from '../../pages/admin/publishers/PublishersList';
import Publisher from '../../pages/admin/publishers/Publisher';
import Admin from '../../pages/admin/publishers/Admin';
import PublisherEdit from "../../components/publisher/admin/PublisherEdit";
import Credentials from '../../pages/admin/publishers/Credentials';
import CmpPublisherConfiguration from "../../pages/admin/publishers/CmpPublisherConfiguration";
import CmpPublisherAnalytics from "../../pages/admin/publishers/CmpPublisherAnalytics";
import SdkConfiguration from '../../pages/admin/publishers/SdkConfiguration';
import PublisherInvoices from '../../pages/admin/publishers/PublisherInvoices';
import PublisherInvoice from '../../pages/admin/publishers/PublisherInvoice';
import PublisherUsers from "../../pages/admin/publishers/PublisherUsers";
import RemoteConfiguration from '../../components/sdk/RemoteConfiguration';
import { get } from 'lodash';

function Publishers(props) {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={PublishersList}/>
        <Route
          exact
          path={`${path}/:publisherId/sdk/remote_configuration`}
          component={
            (props)=>(
              <RemoteConfiguration configurable={
                {
                  remote_configurable_id: get(props, 'match.params.publisherId'),
                  remote_configurable_type: 'Publisher',
                }
              }/>
            )}
        />
        <Route path={`${path}/:publisherId/sdk/configs`}  component={SdkConfiguration}/>
        <Route path={`${path}/:publisherId/admin/edit`} component={PublisherEdit}/>
        <Route path={`${path}/:publisherId/admin`}  component={Admin}/>
        <Route path={`${path}/:publisherId/cmp/configuration`} component={CmpPublisherConfiguration}/>
        <Route path={`${path}/:publisherId/cmp/analytics`} component={CmpPublisherAnalytics}/>
        <Route path={`${path}/:publisherId/credentials`} component={Credentials}/>
        <Route path={`${path}/:publisherId/revenues/:year/:month`} component={PublisherInvoice}/>
        <Route path={`${path}/:publisherId/revenues`} component={PublisherInvoices}/>
        <Route path={`${path}/:publisherId/users`} component={PublisherUsers}/>
        <Route path={`${path}/:publisherId`} component={Publisher}/>
      </Switch>
    </Suspense>
	)
}

export default Publishers
